import React, { useState } from "react";
import { Modal,message } from "antd";
import Axios from "axios";
import { genericUrl } from "../../../constants/serverConfig";
import TableForChart from "./TableForChart";

const TableChartComponent = (props) => {
  const [drillDownPopup, setPopupForDrillDown] = useState(false);
  const [drillDownTitle, setDrillDownTitle] = useState("");
  const [drillDownTableColumns, setDrillDownTableColumns] = useState([]);
  const [drillDownTableData, setDrillDownTableData] = useState([]);
  const { tableChartData, tableKpi, dashboardParamsAndKpiData,fullScreenValue } = props;
  const tableProperties = JSON.parse(tableKpi.properties);
  const columnsDataArr = tableProperties.columnsData;
  for (let index = 0; index < columnsDataArr.length; index++) {
    const element = columnsDataArr[index];
    const title = element.title;
    const dataType = element.type
    element["render"] = (text) => <span style={{ color: element.drillDown === "Y"?"blue":"",float:dataType==="string"?"left":"right" }}>{text===null || text===undefined?'':dataType==="string"?text:text.toLocaleString('en-US')}</span>;
    if (element.drillDown === "Y") {
      element["render"] = (text) => <span style={{ color: "blue" }}>{text}</span>;
      element["onCell"] = (record) => ({
        onClick: () => {
          drillDownForTable(record, tableKpi);
        },
      });
    }
    element["width"] = 100;
    element["ellipsis"] = true;
    element.title = <span className="dragHandler"><b style={{color:"gray", float:dataType==="string"?"left":"right"}}>{title}</b></span>
  }
  


  const drillDownForTable = (record, tableKpi) => {
    try {
      const newToken = JSON.parse(localStorage.getItem("authTokens"));
      const headers = {
        "Content-Type": "application/json",
        Authorization: `bearer ${newToken.access_token}`,
      };
      const kpiData = dashboardParamsAndKpiData.kpiData;
      const drillDownFilter = tableKpi.drilldown_inputfilters;
      const paramsJson = dashboardParamsAndKpiData.dashboardParams;
      paramsJson[drillDownFilter] = record[drillDownFilter];
      const stringifiedJSON = JSON.stringify(paramsJson);
      const jsonToSend = stringifiedJSON.replace(/"/g, '\\"');
      const executeDashboardMutation = {
        query: `query {
             executeDashboard(dashboardId:"${tableKpi.nt_dashboard_id}",kpiId:"${tableKpi.drilldown_kpi_id}",dashboardParam:"${jsonToSend}"){data, messageCode, title, message}
           }`,
      };
      Axios.post(genericUrl, executeDashboardMutation, { headers: headers }, { async: true }, { crossDomain: true }).then((execDashRes) => {
        const responseFromServer = execDashRes.data.data.executeDashboard;
        if (responseFromServer.title === "Success") {
          const successResponse = JSON.parse(responseFromServer.data);
          const tableData = successResponse[tableKpi.drilldown_kpi_id];
          let chartJSON = {};
          for (let chartIndex = 0; chartIndex < kpiData.length; chartIndex += 1) {
            const element = kpiData[chartIndex];
            if (tableKpi.drilldown_kpi_id === element.kpi_id) {
              chartJSON = element;
            }
          }
          const chartProperties = JSON.parse(chartJSON.properties);
          if (chartJSON.type === "Table Chart") {
            const drillDownTableCols = chartProperties.columnsData;
            for (let index = 0; index < drillDownTableCols.length; index++) {
              const element = drillDownTableCols[index];
              const title = element.title;
              const dataType = element.type
              element["render"] = (text) => <span style={{ color: element.drillDown === "Y"?"blue":"",float:dataType==="string"?"left":"right" }}>{text===null || text===undefined?'':dataType==="string"?text:text.toLocaleString('en-US')}</span>;
              element.title = <span className="dragHandler">{title}</span>;
              if (element.drillDown === "Y") {
                element["render"] = (text) => <span style={{ color: "blue" }}>{text}</span>;
                element["onCell"] = (record) => ({
                  onClick: () => {
                    drillDownForTable(record, chartJSON);
                  },
                });
              };
              element.title = <span className="dragHandler"><b style={{color:"gray", float:dataType==="string"?"left":"right"}}>{title}</b></span>
              setPopupForDrillDown(true)
              setDrillDownTitle(record[drillDownFilter])
              setDrillDownTableData(tableData)
              setDrillDownTableColumns(drillDownTableCols);              
            }
          }
        } else {
          console.log("=======>responseFromServer.message<=======", responseFromServer.message);
          message.error(responseFromServer.message)
        }
      });
    } catch (error) {
      console.log("==>error for drill down table<==", error);
    }
  };

  const handleOk=()=>{
    setPopupForDrillDown(false)
  }

  const handleCancel=()=>{
    setPopupForDrillDown(false)
  }

  return (
    <div>
      <TableForChart dataSource={tableChartData} columnsData={columnsDataArr} tableKpi={tableKpi} fullScreenValue={fullScreenValue} dashboardParamsAndKpiData={dashboardParamsAndKpiData} />
      <Modal title={drillDownTitle} visible={drillDownPopup} onOk={handleOk} onCancel={handleCancel} centered width="1000px">
        <TableForChart dataSource={drillDownTableData} columnsData={drillDownTableColumns} tableKpi={tableKpi} dashboardParamsAndKpiData={dashboardParamsAndKpiData} />
      </Modal>
    </div>
  );
};

export default TableChartComponent;
